var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"sparkline",attrs:{"width":_vm.width,"height":_vm.height,"stroke-width":_vm.stroke}},[_c('path',{staticClass:"sparkline--line",attrs:{"d":_vm.shape,"fill":"none"}}),_c('path',{staticClass:"sparkline--fill",attrs:{"d":[_vm.shape, _vm.fillEndPath].join(' '),"stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }